import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import img from "../../assets/images/Wwings.png"
//import clientLogo from "../../assets/images/L&G_Insurance_Logo_Final_W.png"
import clientLogo from "../../assets/images/L&G_Insurance_Logo_Final_c2c_(1).jpg"
//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

// Super Admin

import SuperAdminSidebar from "./Admin/Sidebar"     
import { Link } from "react-router-dom"

const Sidebar = props => {

  const isDevelopment = process.env.NODE_ENV === "development"

  
  // Define the class name based on the environment
  const className = isDevelopment ? "development" : ""

  const { user } = props

  console.log("USER ID:", props.userId)

  const logo = Number(props.userId) === 131 ? clientLogo : img
  //const logo = Number(props.userId) === 1 ? clientLogo : img

  // Collapsing the sidebar to icon-only is toggled elsewhere (the hamburger
  // in Header.js, via the same two body classes) but there was no way back
  // to full width except finding that button again. The logo is the one
  // element that's always visible in either state, so clicking it re-opens
  // the sidebar when it's collapsed. It deliberately only expands — it
  // never collapses on its own click, so it can't be mistaken for a toggle
  // that fights the hamburger button.
  const expandSidebarIfCollapsed = () => {
    const body = document.body
    if (body.classList.contains("vertical-collpsed")) {
      body.classList.remove("vertical-collpsed")
      body.classList.remove("sidebar-enable")
    }
  }

  return (

    <React.Fragment>
      <div className={`vertical-menu ${className}`}>
        {/* The brand box now sizes and centers itself in CSS (see
            $sidebar-brand-height in _vertical.scss) — these used to carry
            manual left/top offsets to paper over a mismatched height, which
            is what let the logo bleed into the menu list below it. */}
        <div
          className="navbar-brand-box"
          onClick={expandSidebarIfCollapsed}
        >
          <Link to="" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="30" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="64" />
            </span>
          </Link>

          <Link to="" className="logo logo-light pb-3">
            <span className="logo-sm">
              <img src={logo} alt="" height="30" />
            </span>
            <span className="logo-lg">
              <img src={logo} alt="" height="64" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
    userId: state.Profile?.Profile?.id,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))